import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../Context/SubscriptionContext';
import PremiumModal from '../components/access/PremiumModal';
import UpgradeScreen from '../components/access/UpgradeScreen';
import { FaRocket, FaCode, FaBrain } from 'react-icons/fa';

const TechnologyList = ({ category, technologies, onBack, mode = "learner", hideBack = false }) => {
  const { canAccessFeature } = useSubscription();
  const [showUpgrade, setShowUpgrade] = useState(false);
  const navigate = useNavigate();

  const isTenantMode = mode === "tenant";

  const handleTechClick = (tech, index) => {
    const slug = tech.title;
    const path = isTenantMode ? `/student/practice/${slug}` : `/practice/${slug}`;
    navigate(path);
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {technologies.map((tech, index) => {
          return (
            <div
              key={index}
              onClick={() => handleTechClick(tech, index)}
              className="premium-card p-6 flex flex-col items-center text-center cursor-pointer group"
            >
              <div className="w-full flex justify-between items-start mb-6">
                 <div className="px-2 py-1 rounded-md bg-green-50 text-[#10B981] text-[9px] font-black uppercase tracking-widest">
                    Available
                 </div>
                 <div className="text-[#94A3B8] group-hover:text-[#5B21B6] transition-colors">
                    <FaRocket size={14} />
                 </div>
              </div>

              <div className="w-20 h-20 mb-6 relative">
                 <div className="absolute inset-0 bg-purple-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-500"></div>
                 <div className="absolute inset-0 bg-white rounded-2xl border border-purple-100 flex items-center justify-center p-4 shadow-sm relative z-10 group-hover:-translate-y-1 transition-transform duration-500">
                    {tech.image ? (
                      <img src={tech.image} alt={tech.title} className="max-w-full max-h-full object-contain" />
                    ) : (
                      <FaCode className="text-[#5B21B6] text-2xl" />
                    )}
                 </div>
              </div>

              <h3 className="text-xl font-black text-[#111827] mb-2 group-hover:text-[#5B21B6] transition-colors">
                {tech.title}
              </h3>
              <p className="text-xs text-[#6B7280] font-medium mb-8 line-clamp-2 min-h-[32px]">
                {tech.description || "Master this technology through structured practice levels."}
              </p>

              <div className="w-full pt-6 border-t border-[#F1F5F9] flex items-center justify-between">
                 <div className="flex flex-col items-start">
                    <span className="text-[9px] font-black text-[#94A3B8] uppercase tracking-widest">Difficulty</span>
                    <span className="text-xs font-bold text-[#111827]">Intermediate</span>
                 </div>
                 <button className="btn-primary !px-4 !py-2 !text-[10px] uppercase tracking-widest !rounded-xl">
                    Start Learning
                 </button>
              </div>
            </div>
          );
        })}
      </div>

      <PremiumModal 
        isOpen={showUpgrade} 
        onClose={() => setShowUpgrade(false)}
        title="Unlock Premium MCQs"
        message="Upgrade to premium for full access to all levels and advanced practice modes."
      >
        <div className="flex justify-center">
            <UpgradeScreen feature="TECH_EXPLORER_MCQ" />
        </div>
      </PremiumModal>
    </div>
  );
};

export default TechnologyList;



